import { get } from 'lodash';
import { connect } from 'react-redux';

import Meeting from './component';

export default connect((state) => ({
  meeting: get(state, ['Meeting', 'chimeMeeting']),
  attendee: get(state, ['Meeting', 'chimeAttendee']),
}))(Meeting);

